export const sendSignalDialogTranslateions = {
    en: {
        'SEND_SIGNAL_DIALOG_TITLE': 'Send a signal to trackers',
        'SEND_SIGNAL_TYPE': 'Signal type',
        'SIGNAL_TYPE_NONE': 'None',
        'SIGNAL_TYPE_ATTENTION': 'Attention',
        'SIGNAL_TYPE_CONFIRMATION': 'Confirmation',
        'SIGNAL_TYPE_WARNING': 'Warning',
        'SIGNAL_TYPE_EMERGENCY': 'Emergency',
        'SEND_SIGNAL_OBJECTS': 'Objects',
        'SEND_SIGNAL_ZONES': 'Zones',
        'SEND_SIGNAL_OBJECTS_OR_GROUPS': 'Objects or groups',
        'SEND_SIGNAL_CANCEL': 'Cancel',
        'SEND_SIGNAL_SEND': 'Send',
        'SEND_SIGNAL_SUCCESS': 'Signal sent',
        'SEND_SIGNAL_ERROR_EMPTY': 'There\'s no devices to send signal to.',
        'SEND_SIGNAL_ERROR_UNKNOWN': 'Error happened during sending signal, please try again',
    },
    ru: {
        'SEND_SIGNAL_DIALOG_TITLE': 'ÐÐ¾ÑÐ»Ð°ÑÑ ÑÐ¸Ð³Ð½Ð°Ð» Ð½Ð° ÑÑÐµÐºÐµÑÑ',
        'SEND_SIGNAL_TYPE': 'Ð¢Ð¸Ð¿ ÑÐ¸Ð³Ð½Ð°Ð»Ð°',
        'SIGNAL_TYPE_NONE': 'ÐÐµ Ð·Ð°Ð´Ð°Ð½',
        'SIGNAL_TYPE_ATTENTION': 'ÐÐ½Ð¸Ð¼Ð°Ð½Ð¸Ðµ',
        'SIGNAL_TYPE_CONFIRMATION': 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ',
        'SIGNAL_TYPE_WARNING': 'ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ',
        'SIGNAL_TYPE_EMERGENCY': 'Ð¢ÑÐµÐ²Ð¾Ð³Ð°',
        'SEND_SIGNAL_OBJECTS': 'ÐÐ±ÑÐµÐºÑÑ',
        'SEND_SIGNAL_ZONES': 'ÐÐ¾Ð½Ñ',
        'SEND_SIGNAL_OBJECTS_OR_GROUPS': 'ÐÐ±ÑÐµÐºÑÑ Ð¸Ð»Ð¸ Ð³ÑÑÐ¿Ð¿Ñ',
        'SEND_SIGNAL_CANCEL': 'ÐÑÐ¼ÐµÐ½Ð°',
        'SEND_SIGNAL_SEND': 'ÐÐ¾ÑÐ»Ð°ÑÑ',
        'SEND_SIGNAL_SUCCESS': 'Ð¡Ð¸Ð³Ð½Ð°Ð» Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½',
        'SEND_SIGNAL_ERROR_EMPTY': 'ÐÑÑÑÑÑÑÐ²ÑÑÑ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð° Ð½Ð° ÐºÐ¾ÑÐ¾ÑÑÐµ Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½ ÑÐ¸Ð³Ð½Ð°Ð».',
        'SEND_SIGNAL_ERROR_UNKNOWN': 'ÐÑÐ¸ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐµ ÑÐ¸Ð³Ð½Ð°Ð»Ð° Ð¿ÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°, Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÐµÑÐµ ÑÐ°Ð·',
    }
};
